import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f796658"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "smsNotifications-content-loading",
  class: "text-center mt-3"
}
const _hoisted_2 = { class: "fa-2x" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_4 = {
  key: 0,
  id: "smsNotifications-content"
}
const _hoisted_5 = { id: "grdSmsNotifications" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 1,
  class: "text-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scheduled" }, " SCHEDULED ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "text-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "denied text-center" }, " DENIED ", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  id: "smsNotifications-message",
  class: "text-center mt-3"
}
const _hoisted_17 = { id: "smsNotifications-message-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "care-assignment-container-smsNotifications" }, null, -1))
const _hoisted_19 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowNotificationContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_neu_card, {
              color: "plain-0",
              class: "p-0 m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_table, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row, {
                      columns: _ctx.columnHeaders,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            key: column,
                            icon: _ctx.columnIcons[column],
                            slot: column,
                            style: {"padding-top":"25px !important"}
                          }, {
                            default: _withCtx(() => [
                              (column == 'DepartmentGroup' || column == 'SkillGroup')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(column), 1)
                                  ], 64))
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]),
                    _createVNode(_component_neu_table_body, { align: "left" }, {
                      default: _withCtx(() => [
                        (_ctx.smsNotificationData != null && _ctx.smsNotificationData.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.smsNotificationData, (dept) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: dept }, [
                                _createVNode(_component_neu_table_row, {
                                  class: "departmentGroupRow",
                                  columns: _ctx.columnHeaders,
                                  slot: _ctx.column
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_label, { slot: "DepartmentGroup" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fas', 'caret-right'],
                                          size: "sm",
                                          class: _normalizeClass([dept.isDeptExpand ? 'collapseIcon': '']),
                                          onClick: ()=> dept.isDeptExpand = !dept.isDeptExpand,
                                          style: {"padding-right":"5px"}
                                        }, null, 8, ["class", "onClick"]),
                                        _createElementVNode("b", null, _toDisplayString(dept.departmentGroup), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["columns", "slot"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dept.skillList, (skill) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: skill }, [
                                    _createVNode(_component_neu_table_row, {
                                      columns: _ctx.columnHeaders,
                                      slot: _ctx.column,
                                      class: _normalizeClass([!dept.isDeptExpand ? 'd-none': '','skillGroupRow'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_neu_label, { slot: "SkillGroup" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fas', 'caret-right'],
                                              size: "sm",
                                              class: _normalizeClass([skill.isSkillExpand ? 'collapseIcon': '']),
                                              onClick: ()=> skill.isSkillExpand = !skill.isSkillExpand,
                                              style: {"padding-right":"5px"}
                                            }, null, 8, ["class", "onClick"]),
                                            _createElementVNode("b", null, _toDisplayString(skill.skillGroup), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["columns", "slot", "class"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.notifData, (dataItem) => {
                                      return (_openBlock(), _createBlock(_component_neu_table_row, {
                                        columns: _ctx.columnHeaders,
                                        slot: _ctx.column,
                                        key: dataItem,
                                        uid: dataItem.rowUniqueId,
                                        staffId: dataItem.staffId,
                                        class: _normalizeClass([!dept.isDeptExpand ? 'd-none' : '' , !skill.isSkillExpand ? 'd-none' : ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_neu_label, {
                                            slot: "Name",
                                            title: dataItem.staffName
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.staffName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Department",
                                            title: dataItem.departmentName
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.departmentName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, { slot: "Phone Number" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.phoneNumber), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_neu_label, { slot: "Received" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.responseDateTime)), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_neu_label, { slot: "Message" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.responseText), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_neu_label, { slot: "Actions" }, {
                                            default: _withCtx(() => [
                                              (dataItem.action === _ctx.receivedNotifType)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      disabled: _ctx.hasShiftEnded(dataItem.shiftStartDateTime, dataItem.shiftEndDateTime),
                                                      "data-rowid": "dataItem.rowUniqueId",
                                                      "data-requestid": "dataItem.notificationRequestId",
                                                      class: "btn btn-link btn-schedule",
                                                      onClick: ($event: any) => (_ctx.scheduleNotificationRequest(dataItem.departmentId, dataItem.group, dataItem.staffId))
                                                    }, " SCHEDULE ", 8, _hoisted_8),
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      disabled: _ctx.hasShiftEnded(dataItem.shiftStartDateTime, dataItem.shiftEndDateTime),
                                                      "data-rowid": "dataItem.rowUniqueId",
                                                      "data-requestid": "dataItem.notificationRequestId",
                                                      class: "btn btn-link btn-deny",
                                                      onClick: ($event: any) => (_ctx.denyNotificationRequest(dataItem.departmentId, dataItem.group, dataItem.staffId))
                                                    }, " DENY ", 8, _hoisted_9)
                                                  ]))
                                                : (dataItem.action === _ctx.approvedNotifType)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                                                  : (dataItem.action === _ctx.deniedNotifType)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["columns", "slot", "uid", "staffId", "class"]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowNotificationMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.smsNotificationMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_18,
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}